import { QueryClient } from '@tanstack/react-query';

/**
 * Global React Query client.
 *
 * Defaults tuned for a mobile PWA:
 * - staleTime 30s: avoid hitting the backend again for the same data within 30s
 *   even when the component re-mounts (tab switches, navigation back, ...)
 * - gcTime 5min: keep inactive cache a bit longer so going "back" feels instant
 * - refetchOnWindowFocus: false — on mobile PWAs, focus events fire constantly
 *   (pull-to-refresh, background / foreground), triggering thundering refetches
 * - retry 1: user-facing failures should surface quickly
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
